import { Text } from '#atoms';
import { Modal } from '#molecules';
import { SetTypeKey } from '#types/exercisePresets';
import { useState } from 'react';
import styled from 'styled-components';

interface WritingSystemChangeModalProps {
  onClose: () => void;
  onChange: (setType: SetTypeKey) => void;
  setType: SetTypeKey;
}

// 기입 방식 변경 모달
export const SetTypeChangeModal = ({
  onClose,
  onChange,
  setType
}: WritingSystemChangeModalProps) => {
  const EXERCISE_WRITING_SYSTEM_LIST = [
    { name: '무게(kg) / 회', value: 'REPWEIGHT' },
    { name: '시간(sec) / 회', value: 'REPTIME' },
    { name: '회', value: 'REP' },
    { name: '시간(sec)', value: 'TIME' }
  ] as const;

  const [selected, setSelected] = useState<SetTypeKey>(setType);

  const onConfirm = () => {
    onClose();
  };

  const onCancel = () => {
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <div className="flex w-full justify-start">
        <Text textStyle="t2">기입 방식 변경</Text>
      </div>
      <div className="w-full flex flex-col gap-8">
        {EXERCISE_WRITING_SYSTEM_LIST.map(item => (
          <SetButton
            selected={selected === item.value}
            onClick={() => {
              setSelected(item.value);
              onChange(item.value);
            }}
            key={item.value}
          >
            {item.name}
          </SetButton>
        ))}
      </div>
      <div className="w-full flex gap-12 mt-20">
        <Button buttonType="cancle" onClick={onCancel}>
          취소
        </Button>
        <Button buttonType="confirm" onClick={onConfirm}>
          확인
        </Button>
      </div>
    </Modal>
  );
};

const SetButton = styled.button<{ selected: boolean }>`
  display: flex;
  padding: 16px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ selected }) =>
    selected ? ' var(--Brand-400, #7750e9)' : 'var(--bg-500, #373245)'};
  background: var(--bg-600, #2e2a3a);
`;

const Button = styled.button<{ buttonType: 'confirm' | 'cancle' }>`
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;

  background: ${({ buttonType }) =>
    buttonType === 'confirm'
      ? 'var(--Brand-400, #7750e9)'
      : 'var(--bg-600, #2e2a3a)'};

  color: ${({ buttonType }) =>
    buttonType === 'confirm'
      ? 'var(--Gray-Scale-100, #EBE9F4)'
      : 'var(--Gray-Scale-400, #bcb8c3)'};

  /* NEW/body_02_medium */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
`;
